import { ROW_PRESETS } from "./layoutDefaults";
import { MdAdd } from "react-icons/md";

interface RowPresetPickerProps {
  onSelect: (presetIndex: number) => void;
}

const PRESET_ICONS: string[] = ["[1]", "[1|1]", "[2|1]", "[1|2]", "[1|1|1]"];

export const RowPresetPicker = ({ onSelect }: RowPresetPickerProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {ROW_PRESETS.map((preset, index) => (
        <button
          key={preset.label}
          type="button"
          onClick={() => onSelect(index)}
          className="flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-700 transition-colors hover:border-indigo-300 hover:bg-indigo-50 dark:border-slate-700 dark:text-slate-300 dark:hover:border-indigo-600 dark:hover:bg-indigo-900/20"
          title={preset.label}
        >
          <MdAdd size={14} />
          <span className="font-mono text-xs text-slate-400">{PRESET_ICONS[index]}</span>
          <span>{preset.label}</span>
        </button>
      ))}
    </div>
  );
};
